import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningYellow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 31,
	viewBox: "0 0 35 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .75,
		d: "M14.9843 1.43108C16.1024 -0.477024 18.8976 -0.477026 20.0157 1.43107L34.6065 26.3318C35.7246 28.2399 34.327 30.625 32.0908 30.625H2.90917C0.673026 30.625 -0.724564 28.2399 0.393508 26.3318L14.9843 1.43108Z",
		fill: "#FFD231"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.5013 10.2085C17.9588 10.2085 18.2948 10.3196 18.5093 10.5418C18.7237 10.7502 18.831 11.0904 18.831 11.5627C18.831 12.0766 18.738 13.2016 18.5522 14.9377C18.3663 16.6599 18.159 18.5002 17.9302 20.4585H17.0724C16.8436 18.5002 16.6363 16.6599 16.4504 14.9377C16.2646 13.2016 16.1716 12.0766 16.1716 11.5627C16.1716 11.0904 16.2789 10.7502 16.4933 10.5418C16.7078 10.3196 17.0438 10.2085 17.5013 10.2085ZM17.5013 21.9585C17.9588 21.9585 18.3163 22.0835 18.5736 22.3335C18.831 22.5696 18.9596 22.9168 18.9596 23.3752C18.9596 23.8335 18.831 24.1877 18.5736 24.4377C18.3163 24.6738 17.9588 24.7918 17.5013 24.7918C17.0438 24.7918 16.6864 24.6738 16.429 24.4377C16.1716 24.1877 16.043 23.8335 16.043 23.3752C16.043 22.9168 16.1716 22.5696 16.429 22.3335C16.6864 22.0835 17.0438 21.9585 17.5013 21.9585Z",
		fill: "white"
	})]
});
export default SvgWarningYellow;
